export const USER_PORTAL_MOCK = {
  firstName: 'John',
  lastName: 'Doe',
  email: 'john@doe.com',
  role: 'CFO',
  organization: 'John SA',
} as const;
